import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = { class: "user-container" }
const _hoisted_2 = { class: "admin-top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_5 = { class: "admin-stage" }
const _hoisted_6 = { class: "elevate" }
const _hoisted_7 = { class: "filter-summary-box" }
const _hoisted_8 = { class: "filter-summary" }
const _hoisted_9 = { class: "filter-chips" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times-circle",
  style: {"font-weight":"300"}
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { style: {"display":"inline-flex","flex":"1","text-align":"right","justify-content":"center"} }
const _hoisted_14 = {
  key: 0,
  class: "fal fa-check-circle",
  style: {"font-size":"20px"}
}
const _hoisted_15 = { style: {"display":"flex","gap":"15px","justify-content":"center"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"display":"flex","gap":"15px","justify-content":"flex-start","align-items":"center"} }
const _hoisted_19 = {
  key: 0,
  class: "site-tag tag-active"
}
const _hoisted_20 = { class: "user-list-item" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "user-email" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invite_s_s_o_users = _resolveComponent("invite-s-s-o-users")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_table = _resolveComponent("imdex-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_imdex_dialog, {
      width: "600",
      value: _ctx.showInviteDialog,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showInviteDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_invite_s_s_o_users, {
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInviteDialogClosed()))
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_imdex_btn, {
        style: {"margin-right":"15px","font-size":"25pt"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/ssa'))),
        text: "",
        compact: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_imdex_btn, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showInviteDialog = true)),
        style: {"margin-right":"10px"},
        outlined: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("usersMgmt.users")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_imdex_btn, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/users/create'))),
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("usersMgmt.createUser")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters, (category) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: category,
                  class: "filter-chip"
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t(_ctx.filterLabels[category])), 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.removeFilter(category)),
                      style: {"color":"inherit"}
                    }, _hoisted_12, 8, _hoisted_10)
                  ])
                ]))
              }), 128))
            ]),
            _createVNode(_component_imdex_btn, {
              onClick: _ctx.clearAllFilters,
              text: "",
              small: "",
              secondary: "",
              class: "clear-all-filters"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("usersMgmt.clearAllFilters")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ], 512), [
            [_vShow, _ctx.hasFilteredUsers]
          ])
        ]),
        _createVNode(_component_imdex_table, {
          id: "users-table",
          loading: _ctx.tableLoading,
          tableData: _ctx.tableData,
          class: "admin-table-container"
        }, {
          "h-name": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("usersMgmt.name")), 1)
          ]),
          "h-email": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("usersMgmt.email")), 1)
          ]),
          "h-isAuth0User": _withCtx(() => [
            _createVNode(_component_FilterDropdown, {
              label: _ctx.auth0Label,
              options: _ctx.auth0Options,
              selected: _ctx.selectedFilters.auth0,
              "onUpdate:selected": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateFilter('auth0', $event)))
            }, null, 8, ["label", "options", "selected"])
          ]),
          "h-isActive": _withCtx(() => [
            _createVNode(_component_FilterDropdown, {
              label: _ctx.statusLabel,
              options: _ctx.statusOptions,
              selected: _ctx.selectedFilters.status,
              "onUpdate:selected": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateFilter('status', $event)))
            }, null, 8, ["label", "options", "selected"])
          ]),
          "h-lastLoggedIn": _withCtx(() => [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("usersMgmt.lastLoggedIn")), 1)
          ]),
          isAuth0User: _withCtx((prop) => [
            (prop.row.isAuth0User)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          lastLoggedIn: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_15, [
              (prop.row.lastLoggedIn != null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.moment(prop.row.lastLoggedIn)
									.locale(_ctx.i18n.global.locale)
									.tz(_ctx.moment.tz.guess())
									.fromNow()), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("usersMgmt.n/a")), 1))
            ])
          ]),
          isActive: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_18, [
              (prop.row.isActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t("usersMgmt.active").toLocaleUpperCase()), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["site-tag tag-inactive", { 'tag-pending': prop.row.isActive == null }])
                  }, _toDisplayString(prop.row.isActive == null
										? _ctx.$t("usersMgmt.pendingActivation").toLocaleUpperCase()
										: _ctx.$t("usersMgmt.inactive").toLocaleUpperCase()), 3))
            ])
          ]),
          name: _withCtx((prop) => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "user-list-avatar",
                style: _normalizeStyle(`background:${prop.row.defaultProfilePicColor};min-width:50px`)
              }, [
                (prop.row.profilePicUrl == null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(prop.row.name[0].toUpperCase()), 1))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "profile-pic",
                      src: _ctx.profilePicMap[prop.row.profilePicUrl],
                      alt: ""
                    }, null, 8, _hoisted_22))
              ], 4),
              _createVNode(_component_imdex_tooltip, {
                nudgeY: -10,
                class: "name-tooltip"
              }, {
                activator: _withCtx((on) => [
                  _createElementVNode("div", _toHandlers(on), [
                    _createElementVNode("span", null, [
                      _createVNode(_component_router_link, {
                        class: "name-link",
                        to: `/users/${prop.row.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(prop.row.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ], 16)
                ]),
                tooltip: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: prop.row.name
                  }, null, 8, _hoisted_23)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          email: _withCtx((prop) => [
            _createElementVNode("span", _hoisted_24, _toDisplayString(prop.row.email), 1)
          ]),
          _: 1
        }, 8, ["loading", "tableData"])
      ])
    ])
  ]))
}